import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Moon } from "lucide-react";
import { scrollToId } from "../../hooks/useLenisScroll";

const NAV_ITEMS = [
  { id: "zodiac", label: "Your Chart" },
  { id: "tarot", label: "Tarot" },
  { id: "services", label: "Services" },
  { id: "pricing", label: "Pricing" },
  { id: "testimonials", label: "Reviews" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const handleClick = (id) => {
    scrollToId(id);
    setOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#05040F]/60 border-b border-[#E8C27A]/10">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-10 h-20">
        <button
          data-testid="nav-logo"
          onClick={() => handleClick("hero")}
          className="flex items-center gap-2 font-display text-lg md:text-xl tracking-[0.2em] gold-gradient-text"
        >
          <Moon size={18} className="text-[#A99BFF]" />
          COSMIC CODE
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => handleClick(item.id)}
              className="nav-link text-sm uppercase tracking-[0.12em]"
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-cta-button"
          onClick={() => handleClick("cta")}
          className="hidden lg:inline-flex btn-gold !py-2.5 !px-6 text-sm"
        >
          <span className="btn-content">Book a Reading</span>
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#E8C27A]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            className="lg:hidden flex flex-col gap-5 px-6 pb-8 pt-2 overflow-hidden"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            {NAV_ITEMS.map((item) => (
              <button
                key={item.id}
                data-testid={`nav-mobile-link-${item.id}`}
                onClick={() => handleClick(item.id)}
                className="text-left nav-link text-sm uppercase tracking-[0.12em]"
              >
                {item.label}
              </button>
            ))}
            <button data-testid="nav-mobile-cta-button" onClick={() => handleClick("cta")} className="btn-gold text-sm text-center">
              <span className="btn-content">Book a Reading</span>
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
